/** Stage-type dependency name for a custom form. */
export const CUSTOM_FORM_DEPENDENCY = 'customForm';

/** Shown when a custom-form submission is stored but its stage's conditions failed. */
export const STAGE_CONDITIONS_NOT_MET_MESSAGE =
  "Saved. This stage's conditions weren't met, so the stage wasn't completed and no triggers ran.";

// FlowStageTypes.dependencies and FlowStage.dependencyIdentifiers are Json columns
// and may arrive as a JSON string instead of an array.
function toArray(value: unknown): unknown[] {
  if (Array.isArray(value)) return value;
  if (typeof value !== 'string') return [];
  try {
    const parsed: unknown = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

/**
 * Ids of the custom forms feeding a stage: the `dependencyIdentifiers` entries at
 * every index whose stage-type dependency is `customForm`, with `string[]` entries
 * flattened. Empty means the stage is not fed by a custom form.
 */
export function getStageCustomFormIds(
  typeDependencies: unknown,
  dependencyIdentifiers: unknown,
): string[] {
  const identifiers = toArray(dependencyIdentifiers);
  const ids = new Set<string>();
  toArray(typeDependencies).forEach((dependency, i) => {
    if (dependency !== CUSTOM_FORM_DEPENDENCY) return;
    const entry = identifiers[i];
    for (const id of Array.isArray(entry) ? entry : [entry]) {
      if (typeof id === 'string' && id !== '') ids.add(id);
    }
  });
  return Array.from(ids);
}
